export default {
  locations: [],
  locationsByAccountId: {},
  loading: false
}
